import { handleResponse, authHeader } from '../helpers'

export const subscriptionScheduleService = {
    getAll,
    add,
    update,
    remove,
}

function getAll (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/subscription/schedule`, requestOptions).then(handleResponse)
}

function add (params) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/schedule`, requestOptions).then(handleResponse)
}

function update (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/subscription/schedule/${params.id}`, requestOptions).then(handleResponse)
}

function remove (id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    }

    return fetch(`/subscription/schedule/${id}`, requestOptions).then(handleResponse)
}
